import { supabase } from '../lib/supabase';

export const testDatabaseConnection = async () => {
  console.log('🔍 Testing Supabase database connection...');

  try {
    const { data, error } = await supabase
      .from('users')
      .select('count')
      .limit(1);

    if (error) throw error;

    console.log('✅ Supabase database connection successful');
    return {
      success: true,
      data: {
        status: 'connected',
        provider: 'Supabase PostgreSQL'
      }
    };

  } catch (error) {
    console.error('❌ Supabase database connection failed:', error);
    return {
      success: false,
      error: 'Database connection failed',
      needsMigration: false
    };
  }
};

export const testAuthConnection = async () => {
  try {
    console.log('🔐 Testing Supabase authentication system...');

    const { data, error } = await supabase
      .from('users')
      .select('count');

    if (error) throw error;

    console.log('✅ Supabase auth system accessible');
    return {
      success: true,
      data: { accessible: true }
    };
  } catch (error) {
    console.error('❌ Supabase auth system error:', error);
    return {
      success: false,
      error: 'Auth system not accessible'
    };
  }
};

export const testTableStructure = async () => {
  console.log('🗄️ Testing Supabase database table structure...');

  try {
    const tablesToCheck = [
      'users',
      'organizations',
      'user_organizations',
      'inventory_items',
      'shipments',
      'shipment_items',
      'invoices',
      'invoice_items'
    ];

    const tables: Record<string, boolean> = {};

    for (const table of tablesToCheck) {
      try {
        const { error } = await supabase
          .from(table)
          .select('count')
          .limit(1);

        tables[table] = !error;
      } catch {
        tables[table] = false;
      }
    }

    console.log('✅ Supabase table structure verified');
    return {
      success: true,
      tables: tables,
      error: null
    };
  } catch (error) {
    console.error('❌ Supabase table structure test failed:', error);
    return {
      success: false,
      error: 'Failed to test table structure'
    };
  }
};
